import AnalyticsPanel from './AnalyticsPanel';

export default AnalyticsPanel;
